export const TL = {
    translations: {
        notifications: 'Notipikasyon',
        markAllAsRead: 'Markahan ang lahat bilang nabasa',
        poweredBy: 'Pinagagana ng',
        settings: 'Settings',
        noNewNotification: 'Wala pang bagong makikita dito',
    },
    lang: 'tl',
};
//# sourceMappingURL=tl.js.map